import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
} from 'beyond-util';

import { OdrzavanjeProgramaComponent } from './odrzavanje-programa.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    NgxSpinnerModule,
  ],
  declarations: [OdrzavanjeProgramaComponent],
  entryComponents: [OdrzavanjeProgramaComponent],
  exports: [OdrzavanjeProgramaComponent],
})
export class OdrzavanjeProgramaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/odrzavanje-programa/odrzavanje-programa.module.ts